module.exports = __webpack_public_path__ + "img/hr-red-pita-03.7eb923a8.png";